<template>
    <grid class="c-m g-m">
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.group_label')}}</b>
            </column>
            <column :xs="7">
                <label class="dock-pull-select-label">
                    <select class="dock-pull-select" name="group_id" v-model="device.group_id">
                        <option v-for="group in groups" :key="group.id" :value="group.id">{{group.name}}</option>
                    </select>
                </label>
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.contract_num_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="contract" :value="device.contract" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.mark_label')}}</b>
            </column>
            <column :xs="7">
                <label class="dock-pull-select-label">
                    <select class="dock-pull-select" name="mark" v-model="device.mark">
                        <option v-for="(mark, key) in marks" :key="key">{{mark}}</option>
                    </select>
                </label>
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.model_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="model" :value="device.model" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.year_label')}}</b>
            </column>
            <column :xs="7">
                <label class="dock-pull-select-label">
                    <select class="dock-pull-select" name="year" v-model="device.year">
                        <option v-for="(year, key) in years" :key="key">{{year}}</option>
                    </select>
                </label>
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.vin_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="vin" :value="device.vin" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.pts_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="pts" :value="device.pts" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.org_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="org_name" :value="device.org_name" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.full_name_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="full_name" :value="device.full_name" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.contact_num_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="contact" :value="device.contact" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.inst_place_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="inst_site" :value="device.inst_site" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" :reverse="!1" start="xs" middle="xs">
            <column :xs="4">
                <b>{{$t('devices.installer_fn_label')}}</b>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" type="text" name="full_name_inst" :value="device.full_name_inst" @input="setDevice">
            </column>
            <column :xs="1"></column>
        </row>
        <row class="c-m" center="xs">
            <column :xs-offset="12">
                <button class="dock-pull-button" @click="$router.push({name:'device_new'})">{{$t('continue_label')}}</button>
            </column>
        </row>
    </grid>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'NewDeviceOptions',
  computed: {
    ...mapGetters({
      device: 'getAddDevice',
      marks: 'getMarks',
      groups: 'getGroupsFromTree'
    }),
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 1900}, (value, index) => year - index)
    }
  },
  methods: {
    ...mapMutations(['updateAddDevice']),
    setDevice (e) {
      this.updateAddDevice({
        prop: e.target.name,
        value: e.target.value
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/devices/new/NewDeviceOptions.vue